/**
 * Parse scrape_results JSON columns that may be plain objects,
 * JSON strings, or double-encoded JSON strings.
 */
export const parseScrapeJson = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'object') return value;

  let current = String(value).trim();
  if (!current) return null;

  for (let i = 0; i < 3; i += 1) {
    try {
      const parsed = JSON.parse(current);
      if (typeof parsed === 'string') {
        current = parsed.trim();
        continue;
      }
      return parsed;
    } catch {
      break;
    }
  }

  return { _raw: current };
};

export const isUuid = (value) => (
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    .test(String(value ?? '').trim())
);
